<template>
      <v-dialog v-model="getLoading" persistent fullscreen>
          <v-layout>  
                <v-row>
                    <v-col cols="12" class="align-self-center text-center">
                        <v-progress-circular indeterminate :size="55" :width="2"  :color="getLoadingColor"></v-progress-circular>
                    </v-col>
                </v-row>
           </v-layout>
      </v-dialog>
</template>

<script>
  export default {
    computed: {
        getLoading() {
            return this.$store.getters.getLoading;
        },
        getLoadingColor() {
            return this.$store.getters.getLoadingColor;
        }
    },
  }
</script>